export default __webpack_public_path__ + "static/media/ic_soundoff.02950e21.svg";